/*
  THE CART, v2 (the CART FORK room, 2026-09-27). Keeps the test side's lines in step with the cart, and tags every cart
  with its side so each checkout and order carries it.
  - The side is drawn once per browser by the inline script in snippets/cart-v2.liquid (window.__cartv, 'A' or 'B').
  - Both sides: the cart gets the private attribute __cart_test = cart_v2_A / cart_v2_B, once per cart token.
  - Side B: the shipping line, personal service under Checkout (its tiers and words: small under $2,500, big, watch, wire),
    the chat-hours line, the text and chat drafts (written for each moment), and the
    two promises that hold only for some carts (the appraisal, the 14-day returns) and the ship dates follow the cart. Every word and every
    figure comes from the Liquid (data- attributes); this file carries none. A promise stays hidden until the facts for
    the cart as it stands are known (snippets/cart-v2-facts, fetched through sections/cart-v2-facts when the pieces
    change). Taps count through traxEmit (select_promotion / view_promotion, promotion_id cart_v2).
  - The store's own chat (window.TraxDesk, desk.traxnyc.com) takes the Chat link itself while it is on and sends the
    cart's draft as the first line; its panel opens under the drawer, so when it opens right after a Chat tap here
    the drawer closes (2026-10-15, Maks: "worth experimenting"). Counted as select_promotion chat_desk.
  Hidden accessory lines (warranties, shipping insurance: window.HIDDEN_CART_HANDLES) never count toward any amount.
*/
(function () {
  if (window.__cv2js) return;
  window.__cv2js = true;

  var PHONE = '+12128729692';

  function side() { return window.__cartv === 'B' ? 'B' : 'A'; }
  // THE $5,000+ LINE TEST (the cart room, 2026-10-26; THE TRAX WAY 46, CART-PLAN.md). On side B, half the browsers see
  // Rodrigo's line on a $5,000-$25,000 cart (arm 'on', the cart as it was); the other half see the $2,500 line in its place
  // ('off'). Drawn once per browser (localStorage trax_bigline_u); ?bigline=on|off forces it for checks and is never stamped.
  // Such a cart carries the private attribute __big_line = on|off. Storage blocked: the cart stays as it was, unstamped.
  var BIG = (function () {
    try {
      var q = location.search.match(/[?&]bigline=(on|off)(?![a-z])/i), f;
      if (q) localStorage.setItem('trax_bigline_f', q[1].toLowerCase());
      f = localStorage.getItem('trax_bigline_f');
      if (f === 'on' || f === 'off') return { arm: f, ok: false };
      var u = parseFloat(localStorage.getItem('trax_bigline_u'));
      if (!(u >= 0 && u < 100)) { u = Math.random() * 100; localStorage.setItem('trax_bigline_u', String(u)); }
      if (parseFloat(localStorage.getItem('trax_bigline_u')) !== u) return { arm: 'on', ok: false };
      return { arm: u < 50 ? 'on' : 'off', ok: true };
    } catch (e) { return { arm: 'on', ok: false }; }
  })();
  function hidden() { return window.HIDDEN_CART_HANDLES || ['1-month-silver-warranty', '6-month-diamond-warranty', '3-month-gold-warranty', 'shipping-insurance']; }
  function num(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }
  function money(cents) {
    try { if (window.cartManager && window.cartManager.formatPrice) return window.cartManager.formatPrice(cents); } catch (e) {}
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function emit(name, data) { try { if (window.traxEmit) window.traxEmit(name, data); } catch (e) {} }
  function all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  // the store's own chat (desk.traxnyc.com): on for this visitor when its status is known and it is not off
  function deskOn() { try { var d = window.TraxDesk; return !!(d && ((d.listReady && d.listReady()) || (d.photoReady && d.photoReady()))); } catch (e) { return false; } }

  function read(cart) {
    var h = hidden(), sub = 0, pieces = 0, watch = false, watchName = '', lines = [], keys = [];
    (cart && cart.items || []).forEach(function (it) {
      if (h.indexOf(it.handle) !== -1) return;
      sub += it.final_line_price || (it.price * it.quantity) || 0;
      pieces += it.quantity || 0;
      if ((it.product_type || '') === 'Watch') { watch = true; if (!watchName) watchName = it.product_title || it.title || ''; }
      var name = it.product_title || it.title || '';
      if (it.variant_title && it.variant_title !== 'Default Title') name += ' (' + it.variant_title + ')';
      if (it.quantity > 1) name = it.quantity + ' x ' + name;
      lines.push(name);
      keys.push(it.key);
    });
    return { sub: sub, pieces: pieces, watch: watch, watchName: watchName, lines: lines, count: lines.length, keys: keys.sort().join('|'), token: cart && cart.token };
  }

  // THE KARAT LINE (the cart room): a half-and-half test from Oct 27 to Nov 2; since Nov 2 every side-B cart that holds karat gold
  // or sterling silver shows the refund policy's karat guarantee in its trust list (Maks, Oct 31: "what's the point of just
  // showing it to half?"; the week's read: no harm). ?trust=off still hides it for checks. Nothing is stamped any more.
  var TRUST = (function () {
    try {
      var q = location.search.match(/[?&]trust=(on|off)(?![a-z])/i);
      if (q) localStorage.setItem('trax_trust_f', q[1].toLowerCase());
      if (localStorage.getItem('trax_trust_f') === 'off') return { arm: 'off', ok: false };
    } catch (e) {}
    return { arm: 'on', ok: false };
  })();
  var trustMarks = {};
  function trustTag(token) {
    if (!TRUST.ok || side() !== 'B' || !token) return;
    var key = 'trax_trust_tag', mark = 'trust|' + token + '|' + TRUST.arm;
    if (trustMarks[mark]) return;
    try { if (localStorage.getItem(key) === mark) return; } catch (e) {}
    trustMarks[mark] = true;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { __trust_line: TRUST.arm } }) })
      .then(function (r) { if (r.ok) { try { localStorage.setItem(key, mark); } catch (e) {} } else { delete trustMarks[mark]; } })
      .catch(function () { delete trustMarks[mark]; });
  }

  function tierOf(state, card) {
    var big = num(card.getAttribute('data-big-from'), 250000), wire = num(card.getAttribute('data-wire-from'), 2500000);
    var big5 = num(card.getAttribute('data-big5-from'), 0);   // v2.2 B: Rodrigo's way to pay from $5,000 (0 = his switch is off)
    if (!state.count) return '';
    var t = state.sub >= wire ? 'wire' : state.watch ? 'watch' : (big5 > 0 && state.sub >= big5) ? 'big5' : state.sub >= big ? 'big' : 'small';
    return (t === 'big5' && BIG.arm === 'off') ? 'big' : t;   // the $5,000+ line test (2026-10-26)
  }

  // the chat hours are the header's (hb-header #dot: data-wd / data-we, 24h ET; the header's defaults 11-22 and 12-22)
  function chatHours(day) {
    var wk = day === 0 || day === 6, dot = document.getElementById('dot');
    var v = (dot && dot.getAttribute(wk ? 'data-we' : 'data-wd')) || (wk ? '12-22' : '11-22'), p = v.split('-');
    return [parseInt(p[0], 10) || 11, parseInt(p[1], 10) || 22];
  }
  function nyDay() { try { var p = {}; new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; }); return parseInt(p.year + p.month + p.day, 10) || 0; } catch (e) { return 0; } }   // New York's day as 20261211
  function ampm(n) { return n < 12 ? n + ' am' : n === 12 ? '12 pm' : (n - 12) + ' pm'; }
  function chatNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var wd = '', hr = 0, mi = 0;
      parts.forEach(function (p) { if (p.type === 'weekday') wd = p.value; if (p.type === 'hour') hr = parseInt(p.value, 10) % 24; if (p.type === 'minute') mi = parseInt(p.value, 10) || 0; });
      var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(wd), h = hr + mi / 60, oh = chatHours(day);
      if (h >= oh[0] && h < oh[1]) return { open: true };
      var today = h < oh[0];
      return { open: false, day: today ? 'today' : 'tomorrow', h: ampm(today ? oh[0] : chatHours((day + 1) % 7)[0]) };
    } catch (e) { return { open: false, day: 'tomorrow', h: '11 am' }; }
  }

  // the facts (appraisal, returns) for the pieces in the cart: first from the page, then from the section when they change
  var facts = null, want = null, asking = null, tries = {};
  function factKeys(f) { return (f && f.keys || []).slice().sort().join('|'); }
  function readFactsFrom(text) { try { var f = JSON.parse(text); return f && f.v === 1 ? f : null; } catch (e) { return null; } }
  (function () { var el = document.querySelector('script[data-cv2-facts]'); if (el) facts = readFactsFrom(el.textContent); })();
  // business days from today, the item page's own count (weekends skipped)
  function addBiz(n) { var d = new Date(), c = 0; while (c < n) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) c++; } return d; }
  function fmtDay(d) { try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString(); } }
  function paintPromises(f) {
    var ok = f && factKeys(f) === want;
    all('[data-cv2-appr]').forEach(function (el) { el.hidden = !(ok && f.appr); });
    all('[data-cv2-ret]').forEach(function (el) { el.hidden = !(ok && f.ret); });
    // the karat line test: the policy's words for the cart's metal, only on the 'on' arm
    var kg = ok && (f.kgold || f.ksilver);
    all('[data-cv2-kg]').forEach(function (el) {
      var t = el.querySelector('[data-cv2-kgt]');
      if (t) t.textContent = el.getAttribute(f && f.kgold ? 'data-t-gold' : 'data-t-silver') || '';
      el.hidden = !(kg && TRUST.arm === 'on');
    });
    if (kg && lastToken) trustTag(lastToken);
    // when it ships, as dates, only for the pieces the facts describe
    all('[data-cv2-when]').forEach(function (el) {
      if (!ok || !f.n) { el.hidden = true; return; }
      if (f.cust) {   // Oct 28: a custom name, initial or photo piece made to order: no dates (production's word); Christmas to Dec 11
        var xm = f.xmas && nyDay() > 0 && nyDay() <= 20261211;
        el.textContent = (el.getAttribute('data-t-cust') || '') + (xm ? (el.getAttribute('data-t-xmas') || '') : '');
        el.hidden = false; return;
      }
      var m = typeof f.mtow === 'boolean' ? f.mtow : !!f.mto;
      var lo = num(el.getAttribute(m ? 'data-mlo' : 'data-lo'), m ? 10 : 2), hi = num(el.getAttribute(m ? 'data-mhi' : 'data-hi'), m ? 15 : 5);
      if (f.hi > 0) { lo = f.lo; hi = f.hi; }   // v2.1: the slowest line's window (the item page's own promise where the line carries it)
      var t = el.getAttribute(m ? 'data-t-mto' : 'data-t-stock') || '';
      if (t) el.textContent = t.replace('{a}', fmtDay(addBiz(lo))).replace('{b}', fmtDay(addBiz(hi)));
      el.hidden = false;
    });
  }
  // round 3: each piece's facts under its title in the drawer (the text is the Liquid's, snippets/cart-v2-line, carried in
  // the facts); the drawer's "SKU:" line repeats the number in the title, so side B hides it where the facts show
  function paintLines(f) {
    if (side() !== 'B' || !f || !f.lines) return;
    var by = {};
    f.lines.forEach(function (l) { if (l && l.k) by[l.k] = l.t || ''; });
    all('#cart-drawer .cart-drawer-item').forEach(function (card) {
      var ke = card.querySelector('[data-line-key]'), h3 = card.querySelector('h3');
      if (!ke || !h3) return;
      var t = by[ke.getAttribute('data-line-key')] || '', old = card.querySelector('.cv2-facts');
      if (!t) { if (old) old.parentNode.removeChild(old); return; }
      var p = old || document.createElement('p');
      p.className = 'cv2 cv2-facts';
      if (p.textContent !== t) p.textContent = t;
      if (!old) {
        var nx = h3.nextElementSibling, after = nx && /text-gray-600/.test(nx.className || '') ? nx : h3;
        after.parentNode.insertBefore(p, after.nextSibling);
      }
      Array.prototype.forEach.call(card.querySelectorAll('p'), function (q) { if (/^\s*SKU:/.test(q.textContent || '')) q.classList.add('cv2-old'); });
    });
  }
  // his line: the ring line when an engagement ring is in the cart, his own line otherwise (both words from the Liquid)
  function paintQuote(f) {
    if (side() !== 'B' || !f) return;
    all('[data-cv2-quote]').forEach(function (q) {
      var t = q.querySelector('[data-cv2-qt]'), w = q.getAttribute(f.eng ? 'data-t-ring' : 'data-t-self');
      if (t && w && t.textContent !== w) t.textContent = w;
    });
  }
  // round 3: "Need a chain for it?" follows the cart: shown when a pendant has no chain, pointing at the pendant's metal
  function paintChainFor(f) {
    if (side() !== 'B' || !f) return;
    all('[data-cv2-chainfor]').forEach(function (box) {
      var pc = f.pc === 'silver' || f.pc === 'gold' ? f.pc : '';
      box.hidden = !pc;
      if (!pc) return;
      var a = box.querySelector('[data-cv2-chainlink]'), href = box.getAttribute('data-href-' + pc), t = box.getAttribute('data-t-' + pc);
      if (a && href) a.setAttribute('href', href);
      if (a && t && a.textContent !== t) a.textContent = t;
    });
  }
  function askFacts() {
    var k = want;
    if (asking === k) return;
    tries[k] = (tries[k] || 0) + 1;
    if (tries[k] > 2) return;          // two asks per cart at most; the promises stay hidden if the facts never match
    asking = k;
    // no Accept: application/json here: /cart answers that header with the cart itself and drops the section
    fetch('/cart?sections=cart-v2-facts', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j['cart-v2-facts'], m = html && html.match(/<script[^>]*data-cv2-facts[^>]*>([\s\S]*?)<\/script>/);
        var f = m ? readFactsFrom(m[1]) : null;
        if (asking === k) asking = null;
        if (!f) return;
        if (factKeys(f) === want) { facts = f; paintPromises(facts); paintLines(facts); paintQuote(facts); paintChainFor(facts); }
        else if (want !== k && factKeys(facts) !== want) askFacts();   // the cart moved on while we asked
      })
      .catch(function () { if (asking === k) asking = null; });
  }

  var seen = {};
  function paint(state) {
    if (side() !== 'B') return;
    // an empty cart shows nothing of the new side
    all('[data-cv2-block]').forEach(function (blk) { blk.hidden = !state.count; });
    // the shipping line: the words come from the Liquid, the threshold too
    // the drawer's Checkout total and the cart page's top block (round 3) follow the cart too
    all('[data-cv2-cta-total],[data-cv2-top-sub]').forEach(function (el) { el.textContent = money(state.sub); });
    all('[data-cv2-pieces]').forEach(function (el) {
      el.textContent = state.pieces === 1 ? (el.getAttribute('data-t-one') || '') : (el.getAttribute('data-t-many') || '').replace('[n]', state.pieces);
    });
    all('[data-cv2-block="summary"],[data-cv2-block="top"]').forEach(function (blk) {
      // free only while the store terms record sets a minimum (a 0 or a missing amount is never free: Maks, Oct 14)
      var us = blk.getAttribute('data-cv2-us') === '1', free = num(blk.getAttribute('data-cv2-free-from'), 0);
      var t = !us ? blk.getAttribute('data-cv2-t-intl') : (free > 0 && state.sub >= free) ? blk.getAttribute('data-cv2-t-free') : blk.getAttribute('data-cv2-t-paid');
      var el = blk.querySelector('[data-cv2-ship]');
      if (el && t) el.textContent = t;
      // under the free line, how much more makes it free (the theme's own tracker's job on this side)
      var note = blk.querySelector('[data-cv2-note]');
      if (note && us) {
        var left = free - state.sub;
        var nt = free <= 0 ? note.getAttribute('data-t-none') : left > 0 ? (note.getAttribute('data-t-left') || '').replace('[x]', money(left)) : note.getAttribute('data-t-free');
        if (nt) note.textContent = nt;
      }
    });
    // the message the shopper sends, already written for the moment it is sent from (so the desk sees why at once):
    // the pieces and the total; a watch question names the watch; the wire line asks for a wire
    function cap(m) { return m.length > 480 ? m.slice(0, 477) + '...' : m; }
    var pieces = state.lines.join(', ') + '. Total ' + money(state.sub) + '.';
    var msgHelp = cap(state.count ? "Hi, I'd like help with my order: " + pieces : "Hi, I'd like help with a piece.");
    var msgWatch = cap(state.watchName ? 'Hi, I have a question about the ' + state.watchName + ' in my cart.' : msgHelp);
    var msgWire = cap(state.count ? "Hi, I'd like to pay for my order by bank wire: " + pieces : msgHelp);
    var anyCard = document.querySelector('[data-cv2-jeweler]');
    var tierNow = anyCard ? tierOf(state, anyCard) : '';
    var msgCard = tierNow === 'watch' ? msgWatch : tierNow === 'wire' ? msgWire : msgHelp;
    all('[data-cv2-sms]').forEach(function (a) {
      var m = /^wire/.test(a.getAttribute('data-cv2-tap') || '') ? msgWire : msgCard;   // the wire line and the wire box ask for a wire
      a.setAttribute('href', 'sms:' + PHONE + '?&body=' + encodeURIComponent(m));
    });
    all('[data-cv2-tap="chat"]').forEach(function (a) { a.setAttribute('data-chat-draft', msgCard); });
    all('[data-cv2-wirechat]').forEach(function (a) { a.setAttribute('data-chat-draft', msgWire); });   // the wire line's chat asks for the wire
    // the jeweler card
    var chat = deskOn() ? { open: true } : chatNow();   // the desk answers at night
    all('[data-cv2-jeweler]').forEach(function (card) {
      var wh = card.closest('[data-cv2-where]'), where = wh ? wh.getAttribute('data-cv2-where') : '';
      var tier = tierOf(state, card);
      if (!tier) { card.hidden = true; card.setAttribute('data-tier', ''); return; }
      card.setAttribute('data-tier', tier);
      var h = card.querySelector('[data-cv2-jh]'), b = card.querySelector('[data-cv2-jb]'), hrs = card.querySelector('[data-cv2-hours]');
      if (h) h.textContent = card.getAttribute('data-h-' + tier) || h.textContent;
      if (b) { var bt = card.getAttribute('data-b-' + tier) || ''; b.textContent = bt; b.hidden = !bt; }
      var line = chat.open ? card.getAttribute('data-open') : (card.getAttribute('data-closed') || '').replace('{day}', chat.day).replace('{h}', chat.h);
      if (hrs && line) hrs.textContent = line;
      card.hidden = false;
      var key = tier + '|' + where;
      if (!seen[key]) { seen[key] = true; emit('view_promotion', { promotion_id: 'cart_v2', promotion_name: 'jeweler_' + tier, creative_slot: where }); }
    });
    // the wire line: only from the jeweler card's threshold, never beside a small cart
    all('[data-cv2-block="body"]').forEach(function (blk) {
      var big = num(blk.getAttribute('data-cv2-big-from'), 250000);
      var top = document.querySelector('[data-cv2-wiretop]'), topFrom = top ? num(top.getAttribute('data-wire-from'), 2500000) : 0;
      blk.querySelectorAll('[data-cv2-wire]').forEach(function (el) { el.hidden = state.sub < big || (top && state.sub >= topFrom); });   // v2.2 C: never said twice
      blk.querySelectorAll('[data-cv2-paycard-intl]').forEach(function (el) { el.hidden = state.sub < big; });   // v2.1: abroad the card holds only the wire line
    });
    // v2.2 C: the wire box above Checkout, from its own amount (only rendered while Maks's switch is on)
    all('[data-cv2-wiretop]').forEach(function (el) { el.hidden = state.sub < num(el.getAttribute('data-wire-from'), 2500000); });
    // the two promises that hold only for some carts
    want = state.keys;
    paintPromises(facts);
    if (state.count && factKeys(facts) !== want) askFacts();
  }

  var tagging = {};
  // v2.1: the device, for the read (phones first); orders and checkouts carry none of their own
  function dev() {
    var ua = navigator.userAgent || '';
    if (/iPad|Tablet|Android(?!.*Mobile)/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'tablet';
    return /Mobi|iPhone|iPod|Android/i.test(ua) ? 'phone' : 'desktop';
  }
  function tag(state) {
    if (!state.token || !state.count) return;
    if (!(window.__cartv_share > 0) && !window.__cartv_forced) return;   // the test is off: the cart is left alone
    var v = 'cart_v2_' + side();
    var key = 'trax_cartv_tag', mark = state.token + '|' + v;
    if (tagging[mark]) return;                      // one tag per cart and side, however many cart events arrive
    try { if (localStorage.getItem(key) === mark) return; } catch (e) {}
    tagging[mark] = true;
    // one count per cart and side, for the read (GA4 through the site pixel, which forwards view_promotion)
    emit('view_promotion', { promotion_id: 'cart_v2', promotion_name: 'side_' + side(), creative_slot: 'cart' });
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { __cart_test: v, __cart_dev: dev() } }) })
      .then(function (r) { if (r.ok) { try { localStorage.setItem(key, mark); } catch (e) {} } else { delete tagging[mark]; } })
      .catch(function () { delete tagging[mark]; });
  }

  // the $5,000+ line test's stamp: side B, a $5,000-$25,000 cart without a watch (the carts the line is shown to), once per cart
  function bigTag(state) {
    if (!BIG.ok || side() !== 'B' || !state.token || !state.count || state.watch) return;
    var card = document.querySelector('[data-cv2-jeweler]');
    var big5 = card ? num(card.getAttribute('data-big5-from'), 0) : 0, wire = card ? num(card.getAttribute('data-wire-from'), 2500000) : 2500000;
    if (!(big5 > 0) || state.sub < big5 || state.sub >= wire) return;
    var key = 'trax_bigline_tag', mark = 'big|' + state.token + '|' + BIG.arm;
    if (tagging[mark]) return;
    try { if (localStorage.getItem(key) === mark) return; } catch (e) {}
    tagging[mark] = true;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { __big_line: BIG.arm } }) })
      .then(function (r) { if (r.ok) { try { localStorage.setItem(key, mark); } catch (e) {} } else { delete tagging[mark]; } })
      .catch(function () { delete tagging[mark]; });
  }

  var lastToken = null;
  function onCart(cart) { var s = read(cart); lastToken = s.token; paint(s); tag(s); bigTag(s); }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) { if (c) onCart(c); }).catch(function () {});
  }

  document.addEventListener('cart:data-updated', function (e) { if (e && e.detail && e.detail.cartData) onCart(e.detail.cartData); else refresh(); });
  document.addEventListener('cart:item-added', function () { setTimeout(refresh, 400); });
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-cv2-tap]') : null;
    if (!a) return;
    var wh = a.closest('[data-cv2-where]'), where = wh ? wh.getAttribute('data-cv2-where') : '';
    emit('select_promotion', { promotion_id: 'cart_v2', promotion_name: a.getAttribute('data-cv2-tap'), creative_slot: where, link_url: a.getAttribute('href') || '' });
  }, true);
  // THE DESK IN SIGHT: the desk catches the Chat link in the capture phase and stops the click, so a Chat tap is
  // remembered on pointerdown / Enter, and when the desk's panel opens within 2 s of it the drawer closes (the panel
  // sits at z-index 9998, the drawer at 9999)
  var chatTap = null;
  function markChat(e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-cv2-tap="chat"],[data-cv2-tap="wire_chat"],[data-cv2-tap="wire_top_chat"]') : null;
    if (!a) return;
    var wh = a.closest('[data-cv2-where]');
    chatTap = { at: Date.now(), where: wh ? wh.getAttribute('data-cv2-where') : '' };
  }
  document.addEventListener('pointerdown', markChat, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter') markChat(e); }, true);
  function watchDesk() {
    var p = document.querySelector('.nd-panel');
    if (!p || !window.MutationObserver) return !!p;
    new MutationObserver(function () {
      if (p.hidden || !chatTap || Date.now() - chatTap.at > 2000) return;
      var w = chatTap.where; chatTap = null;
      emit('select_promotion', { promotion_id: 'cart_v2', promotion_name: 'chat_desk', creative_slot: w, link_url: 'desk' });
      try { if (document.body.classList.contains('cart-drawer-open') && window.cartDrawer && window.cartDrawer.closeDrawer) window.cartDrawer.closeDrawer(); } catch (x) {}
    }).observe(p, { attributes: true, attributeFilter: ['hidden'] });
    return true;
  }
  (function waitDesk(n) { if (watchDesk() || n > 40) return; setTimeout(function () { waitDesk(n + 1); }, 500); })(0);
  document.addEventListener('traxdesk:status', function () { refresh(); });   // the hours line follows the desk once its status is known
  function watchDrawer() {
    var box = document.getElementById('cart-drawer-items');
    if (!box || !window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; if (facts && factKeys(facts) === want) paintLines(facts); }, 60);
    }).observe(box, { childList: true });
  }
  function start() { refresh(); watchDrawer(); if (facts) { paintLines(facts); paintQuote(facts); paintChainFor(facts); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
